import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { setReferralCookies } from '@/lib/utils/referral-cookie'
import { httpClient } from '@/lib/api/http-client'
import { captureAttribution } from '@/lib/utils/attribution'

/**
 * Client effects that should run once for the whole Vite SPA (including public routes).
 *
 * Referral capture: reads ?ref= from the URL on every page load. This must live
 * here rather than on specific pages (ShareTokenPage, etc.) because the plain
 * referral link — https://app.example.com?ref=CODE — lands on the root route.
 * An unauthenticated visitor is immediately redirected to /login or /register by
 * the auth guard, losing the ?ref= param before any route-specific component can
 * read it. Capturing here runs before any routing decision is made.
 */
export function SpaRootLayoutEffects() {
  const [searchParams] = useSearchParams()

  useEffect(() => {
    captureAttribution(searchParams)
    const refCode = searchParams.get('ref')
    if (refCode) {
      setReferralCookies(refCode, 'referral_link')
      void httpClient.post('/referrals/track-click', {
        referralCode: refCode,
        source: 'referral_link',
      }).catch(() => {
        // Referral attribution must never block routing or auth redirects.
      })
    }
  }, [searchParams])

  return null
}
